import { useEffect, useState } from "react";
import VideoRecorder from "./component/VideoComponent";
import FaceDetector from "./component/FaceDetector";
import { v4 as uuidv4 } from 'uuid';
import { Documentation } from "./component/Documentation";
import { DocumentUpload } from "./component/DocumentUpload";
import VideoRecordingComponent from "./component/VideoRecorderCompo";
import { Provider } from "react-redux";
import { store } from "./store/store"; // Adjust the import path as necessary
import CryptoService from './component/CyrptoService';
import CustomAlert from "./UIComponent/CustomAlert";

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  container: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
    textAlign: "center",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
  },
  title: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "red",
  },
  instructions: {
    fontSize: "14px",
    marginBottom: "10px",
  },
  list: {
    textAlign: "left",
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  },
  retryButton: {
    backgroundColor: "#1E3A8A",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
  },
  note: {
    marginTop: "10px",
    fontSize: "12px",
    color: "gray",
  },
};


function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [faceNotmatchStartAgain, setFaceNotmatchStartAgain] = useState(false)
  const [success, setSuccess] = useState(false);
  const [optStatus, setOptstatus] = useState(false);
  const [videoStatus, setVideoStatus] = useState(false);
  const [popMessage, setPopMessage] = useState(false);
  const [popMessageText, setPopMessageText] = useState('');
  const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  const [flowDoc, setFlowDoc] = useState('');
  const [documentImage, setDocumentImage] = useState('');
  const [documentUplaod, setDocumentUpload] = useState(true);
  const [validDocument, setvalidDocument] = useState(false);
  const [refId, setERefID] = useState('');
  const [requestType, setRequestType] = useState('');
  const [token, setToken] = useState()
  const [clientId, setClientId] = useState('')
  const [requestId, setRequestId] = useState('')
  const [customAlert, setCustomAlert] = useState({ show: false, message: '' });

  const showAlert = (message) => {
    setCustomAlert({ show: true, message });
  };

  useEffect(() => {

    if (optStatus) {
      setTimeout(() => {
        setVideoStatus(true)
      }, 2000)
    }

    // Encrypt
    // const encrypted = CryptoService.encrypt(obj);
    // console.log('Encrypted:', encrypted);
    // Decrypt
    // const decrypted = CryptoService.decrypt(obj);
    // console.log('Decrypted:', JSON.parse(decrypted));

  }, [optStatus]);

  useEffect(() => {
    
    const checkConnection = async () => {
      try {
        await fetch('https://www.google.com/favicon.ico', {
          method: 'HEAD',
        cache: 'no-cache',
        mode: 'no-cors'
        });
        setIsOnline(true);
      } catch {
        setIsOnline(false);
      }
    };

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    checkConnection();
    const interval = setInterval(checkConnection, 5000);

    return () => {
      clearInterval(interval);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = (params.get("t")) || 0;
    if (!t) {
      setPopMessageText("Authorization token is missing in the URL.")
      setPopMessage(true)
      return;
    }
    const myHeaders = new Headers();
    myHeaders.append("Authorization", t);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch("https://dgxnurl2a2.execute-api.ap-south-1.amazonaws.com/v1/ovd_token_validation", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setRequestId(result.data.data.requestid)
        setClientId(result.data.data.clientname)
      })
      .catch((error) => {
        console.error(error);
        setPopMessageText("Invalid authorization token.")
        setPopMessage(true)
      });

    setToken(t)
  }, []);

  useEffect(() => {
    requestLocation()
    requestCameraPermissions()
    requestMicPermissions()
  }, []);

  const requestLocation = () => {

    if (!navigator.geolocation) {
      // alert("Geolocation is not supported by your browser.");
      setPopMessageText("Geolocation is not supported by your browser.")
      setPopMessage(true)
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("Location:", position.coords);
      },
      (err) => {
        setRequestType('mic')
        setPopMessageText("Location permission is required to continue")
        setPopMessage(true)
      }
    );
  };

  const requestCameraPermissions = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ video: true });
      // alert(""); // permission granted
    } catch (err) {
      // alert("Camera permission is required to continue.");
      setRequestType('camera')
      setPopMessageText("Camera permission is required to continue.")
      setPopMessage(true)
    }
  };

  const requestMicPermissions = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      // alert(""); // permission granted
    } catch (err) {
      setRequestType('mic')
      setPopMessageText("Microphone permission is required to continue.")
      setPopMessage(true)
    }
  };

  const handleDocumentUplaod = () => {
    setDocumentUpload(false)
  }

  // const handlePermissionRequest = async () => {
  //   console.log('kets',requestType);

  //   try {
  //     if (requestType === "camera" || requestType === "mic") {
  //       // Request camera/microphone access
  //       await navigator.mediaDevices.getUserMedia({
  //         video: requestType === "camera",
  //         audio: requestType === "microphone",
  //       });
  //       // setPermissions((prev) => ({ ...prev, [requestType]: "granted" }));
  //       setPopMessage(false)
  //       setPopMessageText('')
  //     } else if (requestType === "geolocation") {
  //       // Request location access
  //       navigator.geolocation.getCurrentPosition(
  //         // () => setPermissions((prev) => ({ ...prev, location: "granted" })),
  //         // () => setPermissions((prev) => ({ ...prev, location: "denied" }))
  //       );
  //     }
  //   } catch (error) {
  //      setPopMessage(false)
  //       setPopMessageText('')
  //     // setPermissions((prev) => ({ ...prev, [requestType]: "denied" }));
  //     console.log(`${requestType} permission denied or unsupported`, error);
  //   }
  // }

  if (popMessage) {
    return <>
      <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', height: '100vh' }}>
        <div style={styles.modal}>
          <div style={styles.container}>
            <h2 style={styles.title}>Allow Permissions</h2>
            <p style={styles.subtitle}>{popMessageText}</p>
            <p style={styles.instructions}>Steps to continue to use</p>
            <ol style={styles.list}>
              <li>Click The Lock Icon On Top-Left Of The Screen.</li>
              <li>Click "Site Settings"</li>
              <li>Click "Clear & Reset"</li>
              <li>Click On "Retry Button"</li>
            </ol>
            <button style={styles.retryButton} onClick={() => window.location.reload()}>RETRY</button>
            <p style={styles.note}>
              <strong>Note:</strong> If you didn’t deny location permission, kindly copy the link and open in other Browser.
            </p>
          </div>
        </div>
      </div>
    </>
  }

  if (success) {

    return <>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        gap: '8px',
        padding: '8px',
        backgroundColor: '#d4edda',
        color: '#155724',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        width: 'fit-content'
      }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
        <span style={{ fontSize: '14px', fontWeight: '500' }}>OVD Successfully Completed</span>
      </div>
    </>
  }

  const componentsMap = {
    DocumentUpload: (
      <DocumentUpload
        setFlowDoc={setFlowDoc}
        setDocumentImage={setDocumentImage}
        setvalidDocument={setvalidDocument}
        setERefID={setERefID}
        refId={refId}
        clientId={clientId}
        requestId={requestId}
      />
    ),
    VedioRecorder: (
      <VideoRecordingComponent
        setFlowDoc={setFlowDoc}
        setSuccess={setSuccess}
        documentImage={documentImage}
        setFaceNotmatchStartAgain={setFaceNotmatchStartAgain}
        refId={refId}
        clientId={clientId}
        requestId={requestId}
        showAlert={showAlert}
      />
    ),
    default: (
      <Documentation
        setFlowDoc={setFlowDoc}
        handleDocumentUplaod={handleDocumentUplaod}
        setDocumentImage={setDocumentImage}
        faceNotmatchStartAgain={faceNotmatchStartAgain}
        setERefID={setERefID}
        setSuccess={setSuccess}
        clientId={clientId}
        requestId={requestId}
        showAlert={showAlert}
      />
    ),
  };



  return <>
    <Provider store={store}>
      {!isOnline && (
        <div style={styles.modal}>
          <div style={styles.container}>
            <h2 style={styles.title}>No Internet Connection</h2>
            <p style={styles.subtitle}>Please check your network and try again.</p>
            <button style={styles.retryButton} onClick={() => window.location.reload()}>Retry</button>
          </div>
        </div>
      )}

      <CustomAlert
        isOpen={customAlert.show}
        message={customAlert.message}
        onClose={() => setCustomAlert(prev => ({ ...prev, show: false }))}
      />

      {
        token &&
        <div style={{ position: 'relative' }}>
          {componentsMap[flowDoc] || componentsMap.default}
        </div>
      }
      {/* <div style={{ position: 'relative' }}>
        {componentsMap[flowDoc] || componentsMap.default}

        <Documentation
        setFlowDoc={setFlowDoc}
        handleDocumentUplaod={handleDocumentUplaod}
        faceNotmatchStartAgain={faceNotmatchStartAgain}
      />
      <DocumentUpload
        setFlowDoc={setFlowDoc}
        setDocumentImage={setDocumentImage}
        setvalidDocument={setvalidDocument}
      />
        <VideoRecordingComponent
        setFlowDoc={setFlowDoc}
        setSuccess={setSuccess}
        documentImage={documentImage}
        setFaceNotmatchStartAgain={setFaceNotmatchStartAgain}
      />
      </div> */}
    </Provider>
  </>

}

export default App;